// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modules[data-v-a437fac2] {\n  padding-left: 40px;\n}\n.modules-title[data-v-a437fac2] {\n  margin-bottom: 6px;\n}\n.modules-title span[data-v-a437fac2] {\n  font-size: 16px;\n  color: #606266;\n}\n.modules-title button[data-v-a437fac2] {\n  padding-left: 8px;\n}\n.modules-title .delete-btn[data-v-a437fac2] {\n  color: red;\n}\n.margin-bottom-6[data-v-a437fac2] {\n  margin-bottom: 6px;\n}\n.margin-bottom-10[data-v-a437fac2] {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
